// extracted by mini-css-extract-plugin
export var desc = "style-module--desc--ffebc";
export var imgMb = "style-module--img-mb--09931";
export var imgTb = "style-module--img-tb--e25dc";
export var info = "style-module--info--0ec3c";
export var screen1 = "style-module--screen1--d3bc0";